import React, { Component } from 'react';
import styles from './Feed.module.css';
import Post from './Post/Post';
import axios from 'axios';
import {connect} from 'react-redux';
import PictureFrame from '../Modal/PictureFrame/PictureFrame';

class Feed extends Component {
 
    constructor(props) {
        super(props);
        this.state= {
            user:{},
            users: {},
            posts: [],
            pictureFrame: {
                isModalOpen: false,
                post:{}
            }
        }
        if(localStorage.getItem('feed_posts')) {
            const posts = JSON.parse(localStorage.getItem('feed_posts'));
            const users =JSON.parse(localStorage.getItem('feed_users'));
            this.state.posts= posts;
            this.state.users = users;
        }
    }

    componentDidMount() {
        axios.get('/users.json?auth='+ this.props.loginStatus.authToken)
        .then(users=>{
        axios.get('/users/'+this.props.loginStatus.userId+'/following.json?auth='+ this.props.loginStatus.authToken)
        .then(following=>{
            const posts = [];
            following.data.slice(1).map(userId => {
                const userData = users.data[userId];
                if(userData.account_status === 'DISABLED') return;
                userData.posts.slice(1).map((post, index) => {
                    return post.name = userData.name,
                           post.profilePic = userData.profilePic,
                           post.userId = userId,
                           post.isVerified = userData.isVerified,
                           post.index = index;
                })
             posts.push(...userData.posts.slice(1));  
            });
            posts.sort(this.sort);
            this.setState({posts: posts, users: users.data});
            localStorage.setItem('feed_posts',JSON.stringify(posts));
            localStorage.setItem('feed_users',JSON.stringify(users.data));
        })
     })
    }

    componentWillUnmount() {
        localStorage.setItem('feed_posts',JSON.stringify(this.state.posts));
        localStorage.setItem('feed_users',JSON.stringify(this.state.users));
    }
    sort = (el1, el2) => {
        return new Date(el1.timestamp) > new Date(el2.timestamp) ? -1 : 1;
    }

    openPictureFrame = (index) => {
        const modal = {...this.state.pictureFrame};
        modal.isModalOpen = !this.state.pictureFrame.isModalOpen;
        modal.post = {...this.state.posts[index]};
        modal.post.index = modal.post.index + 1;
        modal.post.postIndex = index;
        this.setState({pictureFrame: modal, user: this.state.users[modal.post.userId]});
    }

    closePictureFrame = () => {
        const modal = {...this.state.pictureFrame};
        modal.isModalOpen = !this.state.pictureFrame.isModalOpen;
        this.setState({pictureFrame: modal});
    }

    onResponseHandler = (postObj) => {
        const posts = [...this.state.posts];
        posts.splice(postObj.postIndex, 1, postObj);
        this.setState({posts: posts});
    }

    render() {
        return(
            <div className={styles.feed}>
                <section>
                    <div className={styles.top}>
                        {this.state.posts.map((post, index)=>{
                           return <Post key={index} {...post} postIndex={index}
                                  openPictureFrame={()=>this.openPictureFrame(index)} 
                                  onResponse={this.onResponseHandler}/>
                        })
                        }
                    
                    </div>
                    {this.state.pictureFrame.isModalOpen ? 
                    <PictureFrame {...this.state.pictureFrame.post} user={this.state.user} 
                    users={this.state.users} close={this.closePictureFrame} 
                    onResponse={this.onResponseHandler}/> : null
                    }
                </section>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus
    }
}

export default connect(mapStateToProps)(Feed);